import request from '@/utils/request'
// 回传配置页面顶部筛选列表
export function platformSelectList(params) {
  return request({
    url: '/novel_management/wechat_platforms',
    method: 'get',
    params
  })
}
// 获取平台下所有账号
export function getList(params) {
  return request({
    url: '/platform/py_platform_account',
    method: 'get',
    params
  })
}
// 删除某个账号
export function deleteLi(id) {
  return request({
    url: `/platform/py_platform_account/${id}`,
    method: 'delete'
  })
}

// 添加账号
export function addAccount(data) {
  return request({
    url: '/platform/py_platform_account',
    method: 'post',
    data
  })
}
// 改变账号状态
export function changeStatus(id, data) {
  return request({
    url: `/platform/py_platform_account/${id}`,
    method: 'put',
    data
  })
}

// 获取公众号
export function accountList(params) {
  return request({
    url: '/platform/py_wechat_account_crontab',
    method: 'get',
    params
  })
}

// 添加公众号
export function addAccountItem(data) {
  return request({
    url: '/platform/py_wechat_account_crontab',
    method: 'post',
    data
  })
}

// 更新公众号粉丝状态
export function updateAccount(id, data) {
  return request({
    url: `/platform/py_wechat_account_crontab/${id}`,
    method: 'put',
    data
  })
}

// 更新公众号粉丝状态
export function deleteAccount(id) {
  return request({
    url: `/platform/py_wechat_account_crontab/${id}`,
    method: 'delete'
  })
}
// 公众号组列表
export function getAccountGroup(params) {
  return request({
    url: '/novel_management/wechat_accounts',
    method: 'get',
    params
  })
}
// 公众号筛选条件列表
export function getSelectList() {
  return request({
    url: '/novel_management/novel_report_selects',
    method: 'get'
  })
}
// 公众号组下面的子列表
export function getofficialList(params) {
  return request({
    url: '/novel_management/msrelation',
    method: 'get',
    params
  })
}
// 创建公众号组绑定
export function creatAccountItem(data) {
  return request({
    url: '/novel_management/msrelation',
    method: 'post',
    data
  })
}
// 更新公众号组绑定
export function updateAccountItem(id, data) {
  return request({
    url: `/novel_management/msrelation/${id}`,
    method: 'put',
    data
  })
}
// platform/py_platform_account/38 修改密码
export function modifyPwd(id, data) {
  return request({
    url: `/platform/py_platform_account/${id}`,
    method: 'put',
    data
  })
}
// 删除公众号组绑定
export function deleteAccountItem(id) {
  return request({
    url: `/novel_management/msrelation/${id}`,
    method: 'delete'
  })
}
// 获取公众号下拉筛选项 公众号组报表使用 公众号组绑定
export function getWechataccountlist() {
  return request({
    url: '/common/wechat_account_list',
    method: 'get'
  })
}
// 获取错误信息列表
export function geterrorinform(params) {
  return request({
    url: '/platform/py_account/errinfo_detail',
    method: 'get',
    params
  })
}
// 更改错误信息状态
export function editerrorinform(data) {
  return request({
    url: '/platform/py_account/update_errinfo',
    method: 'post',
    data
  })
}
// 渠道关系列表
export function getrelationshiplist(params) {
  return request({
    url: '/novel_management/channel_msrelation',
    method: 'get',
    params
  })
}
// 渠道筛选列表
export function getselectlist(params) {
  return request({
    url: '/novel_management/channel/list',
    method: 'get',
    params
  })
}
// 小程序渠道筛选列表
export function getwechatselectlist(params) {
  return request({
    url: '/novel_management/channel/miniprogram_list',
    method: 'get',
    params
  })
}
// 小说小程序渠道筛选列表
export function novel_getwechatselectlist(params) {
  return request({
    url: '/novel_management/channel/novel_miniprogram_list',
    method: 'get',
    params
  })
}

// 渠道关系存储
export function channelstorage(data) {
  return request({
    url: '/novel_management/channel_msrelation',
    method: 'post',
    data
  })
}
// 渠道关系更新
export function updateChannel(id, data) {
  return request({
    url: `/novel_management/channel_msrelation/${id}`,
    method: 'put',
    data
  })
}
// 渠道成本导入
export function costChannel(data = {}) {
  return request({
    url: `/import/channel_cost`,
    method: 'POST',
    data
  })
}
export function deleteChannel(id) {
  return request({
    url: `/novel_management/channel_msrelation/${id}`,
    method: 'delete'
  })
}

export function importR(data = {}) {
  return request({
    url: `/import/channel`,
    method: 'POST',
    data
  })
}

// 获知管理员是否超管
export function isExceeded() {
  return request({
    url: `/platform/py_sign`,
    method: 'get'
  })
}

export function getSearchLists() {
  return request({
    url: `/common/specific_platform_list`,
    method: 'get'
  })
}

// 绑定书籍
export function bindBooks(data = {}) {
  return request({
    url: `/novel_management/channel/add_channel_novel`,
    method: 'post',
    data
  })
}

export function novelListScreen(params) {
  return request({
    url: `/common/novel_list`,
    method: 'get',
    params
  })
}

// 更新渠道管理员
export function updateChannelAdministrator(id, data = {}) {
  return request({
    url: `/novel_management/channel/${id}`,
    method: 'put',
    data
  })
}

// 绑定广告主
export function bindAdvertisers(data = {}) {
  return request({
    url: `/novel_management/binding_advertiser`,
    method: 'put',
    data
  })
}

// 获取广告主列表
export function advertiserList(params = {}) {
  return request({
    url: `/novel_management/advertiser_list`,
    method: 'GET',
    params
  })
}

// 获取渠道绑定的账号
export function getTheAccountNumber(channel_id) {
  return request({
    url: `/novel_management/binding_advertiser_detail`,
    method: 'GET',
    params: {
      channel_id
    }
  })
}

// 清除错误信息
export function myClearErrorMessages(data = {}) {
  return request({
    url: `/platform/py_wechat_account_crontab/errinfo_clean`,
    method: 'post',
    data
  })
}

// 公众号绑定详情
export function bindingDetailsOfOfficialAccount(params = {}) {
  return request({
    url: `/novel_management/wechat_binding_advertiser_detail`,
    method: 'get',
    params
  })
}

// 公众号绑定广告主
export function officialAccountBindingAdvertisers(data = {}) {
  return request({
    url: `/novel_management/wechat_binding_advertiser`,
    method: 'PUT',
    data
  })
}
